<template>
  <f7-page id="privacy-policy-page" name="privacy-policy-page" @page:afterin="afterin">
   <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link @click="goBack()" class="customBack" color="black"><i class="f7-icons">chevron_left</i></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>
        <div class="col-70 text-align-left mb-xl">
          <div class="wandr-title-1">{{$t('sendmoney-privacy-policy')}}</div>
          <!-- <div class="wandr-subtitle-1">{{$t('general-text-updated')}} {{updatedDate}}</div> -->
        </div>
        <div>
          <p>In Singapore and Hong Kong, services are provided by Pay2Home Pte. Ltd., Wandr Pte. Ltd. and P2H (Hong Kong) Pte.
          Limited, doing business under and as part of the Wandr-E group. For the avoidance of any doubt, any reference to
          “Wandr-E”, “us”, “we” or “our”, used in this Privacy Policy shall include Pay2Home Pte. Ltd., Wandr Pte. Ltd. and P2H
          (Hong Kong) Pte. Limited. </p>

          <p>Wandr-E operates and provides the following platforms on which Wandr-E collects, uses, stores, protects, discloses, and
          shares your personal information or data: </p>

          <ol class="faq-content-list" type="a">
            <li>Wandr-E website at <a href="#" @click="followLink('mkt','https://www.wandr-e.com')">www.wandr-e.com</a>;</li>
            <li>Wandr-E Mobile Application (“Mobile App”); </li>
            <li>Wandr-E Referral Program;</li>
          </ol>

          <p>The services provided when you use the above platforms, contact us, access our websites or applications, or join our
          referral programs include the provision of foreign exchange, local transfers, international transfers, referral programs,
          Account, Client and Beneficiary management, Mobile App and Website.</p>

          <p>We collect personal information about you which we may use along with other information collected or generated during
          our relationship with you.</p>

          <p>We care about your privacy and are committed to processing your personal information in accordance with all applicable
          data protection laws to better serve you. This page informs you of our policies regarding the collection, use, and disclosure
          of personal data by us when you use our Services either online through our website and through our mobile app, and the
          choices you have associated with that data. It also includes details about the choices we offer you in relation to that data.
          Personal information means all information or data relating to an identified or identifiable individual. </p>

          <p>We use your data to provide and improve our Services. By using the Services, you agree to the collection and use of
          information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy
          Policy have the same meanings as in our Terms and Conditions, accessible from <a href="#" @click="followLink('mkt','https://www.wandr-e.com/termsandconditions')">www.wandr-e.com/termsandconditions</a>.</p>

          <h1 class="wandr-title-1 mb-0 fw-bold">Information Collection and Use</h1>
          <p>We collect several different types of information about you for various purposes in order to provide and improve our
          Services to you.</p>

          <h2 class="wandr-subtitle-1 mb-0 fw-bold">Types of Data Collected</h2>
          <h3 class="wandr-subtitle-2 mb-0 fw-bold">Personal Data</h3>

          <p>While using our Services, we may ask you to provide us with certain personally identifiable information that can be used
          to contact or identify you ("<b>Personal Data</b>"). Such personally identifiable information may include, but is not limited to:</p>

          <ul>
            <li>Contact information, for example your full name, postal address, e-mail address, telephone number, date of
            birth, gender, citizenship, occupation, marital status, and government or national identification numbers; </li>

            <li>Transaction information, including your money transfers and bill payments;</li>

            <li>Business related information, including your membership in our referral programs, your use of our Services,
            bank and credit information, employer information and permissions to contact or marketing choices; </li>

            <li>Compliance information, including fraud prevention, identity verification, and sanction checks;</li>

            <li>Cookies and Usage Data.</li>
          </ul>

          <p>In addition to the Personal Data we collect from you, we may also collect your personal information from the person to
          whom you send and/or receive money, as well as our Agents, vendors, business partners, identity verification companies,
          payments and fraud risk management companies, law enforcement bodies, and commercial and public data sources.</p>

          <p>We may also provide you with the option of using identification verification technologies offered by any third-party Service
          Providers, that analyses your facial imagery for heightened security, subject to the applicable terms and conditions.</p>

          <p>Failure to provide some of your Personal Data may affect our ability to provide our Services to you.</p>

          <h3 class="wandr-subtitle-2 mb-0 fw-bold">Usage Data</h3>

          <p>We may also collect information about how the Services are accessed and used ("<b>Usage Data</b>"). This Usage Data may
          include (but is not limited to) information such as your computer's Internet Protocol address, browser type, browser
          version, the pages of our website that you visit, the time and date of your visit, the time spent on those pages, unique
          device identifiers, information about your mobile device (such as device properties, settings, applications, biometric data
          such as Touch ID/Fingerprint/Facial Recognition to verify your identity, storage and usage information), Mobile App,
          browser and operating system software, social profile and network, and other diagnostic data.
          </p>

          <h3 class="wandr-subtitle-2 mb-0 fw-bold">Financial Data</h3>

          <p>In order to comply with AML/CTF Laws, assess creditworthiness, and process payments, remittances and/or transactions,
          we may collect financial information such as bank account details (account number, routing number), credit or debit card
          numbers, credit information or reports or tax information, such as withholding allowances and filing status.</p>

          <h3 class="wandr-subtitle-2 mb-0 fw-bold">Tracking & Cookies Data</h3>

          <p>Our web sites and Mobile App uses cookies, which are files with small amount of data, which may include an anonymous
          unique identifier, that are placed on your computer by websites that you visit. Cookies are sent to your browser from a
          website and stored on your device. Cookies are widely used in order to make websites operate more efficiently, as well
          as to provide business and marketing information to better serve you.</p>

          <p>Wandr-E uses such cookies and/or other tracking technologies (such as beacons, tags, and scripts) to collect and track
          information and to improve and analyse the services provided to you. The Services we provide when you use our website,
          Mobile App and/or sign up to any of our referral programs all use cookies. </p>

          <p>You may instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not
          accept cookies, you may not be able to use some portions of our Services.</p>

          <p>Some examples of the type of cookies that Wandr-E uses, include but are not limited to the following:</p>

          <p class="pl-md"><b>Session Cookies</b>: We use session cookies to operate our Services;
          <br><br><b>Preference Cookies</b>: We use preference cookies to remember your preferences and various settings;
          <br><br><b>Security Cookies</b>: We use security cookies for security purposes;
          <br><br><b>Marketing Cookies</b>: We use marketing cookies for customer behaviour analytics.</p>
         
          <p>Wandr-E uses such cookies to personalise content and ads, to provide social media features and to analyse our traffic.
          We also share information about your use of our site with our social media, advertising and analytics partners who may
          combine it with other information that you’ve provided to them or that they’ve collected from your use of their
          services. Wandr-E also uses such cookies to assist us in fraud prevention and detection. 
          </p>

          <p>In some cases, some of these cookies are managed for us by third parties, but we don't allow the third party to use the
          cookies for any purpose other than listed above. For the removal of 3rd party cookies from your computer, you may need
          to manage cookie preferences through your browser settings.</p>

          <p>By continuing to use our Services, including our web browser and mobile apps, you agree and accept that we will access
          your information stored on the cookies. If you do not wish to accept our use of cookies, you may choose to block, delete,
          or disable cookies as your browser or device permits in respect of web browsers, and to not use or stop using our mobile
          apps.</p>

          <h1 class="wandr-title-1 mb-0 fw-bold">How Data is Collected </h1>

          <p>We collect your Personal Data in several ways:</p>

          <ul>
            <li>Through transaction forms and your interactions with our agents and partners;</li>
            <li>Through online forms, registrations for referral and rewards programs or competitions, and other online Services
            we offer (some of which may be managed by third parties on our behalf);</li>
            <li>While providing customer support or consultation, including using email, postal mail, call centres or live chat;</li>
            <li>Through the process of maintaining and upgrading our Services;</li>
            <li>Through automated means such as communications protocols, e-mail communications and cookies; </li>
            <li>Through our Mobile App (whether such may be managed by third parties on our behalf);</li>
            <li>Through your use of social media or other public data sources; and</li>
            <li>Through your interest in our advertisements placed on third party sites.</li>     
          </ul>

          <h1 class="wandr-title-1 mb-0 fw-bold">Use of Data</h1>

          <p>Wandr-E uses the collected data for various purposes:</p>

          <ul>
            <li>To provide and maintain the Services;</li>
            <li>To notify you about changes to our Services;</li>
            <li>To allow you to participate in interactive features of our Services when you choose to do so;</li>
            <li>To provide customer care and support;</li>
            <li>To provide analysis or valuable information so that we can improve the Services;</li>
            <li>To monitor the usage of the Services;</li>
            <li>To detect, prevent and address technical issues.</li>
          </ul>

          <h1 class="wandr-title-1 mb-0 fw-bold">Transfer and Retention of Data</h1>

          <p>Your information, including Personal Data, may be transferred to, and maintained on, computers located outside of your
          state, province, country, or other governmental jurisdiction where the data protection laws may differ than those from your
          jurisdiction.
          </p>

          <p>If you are located outside Singapore and choose to provide information to us, please note that we transfer the data,
          including Personal Data, to Singapore and process it there.</p>

          <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that
          transfer.</p>

          <p>Wandr-E will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this
          Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are
          adequate controls in place including the security of your data and other personal information.
          </p>

          <p>Your Personal Data will be retained in accordance with statutory periods contained in regulations applicable to financial
          transactions including those in anti-money laundering, anti-terrorist financing and other laws applicable to us. Otherwise,
          we will retain your information only if necessary for the specific purposes it was collected, or to resolve any query you
          may raise. We will typically keep your information for no longer than the purpose(s) for which it was obtained, unless we
          have a legal obligation to keep it for a longer period or retention is advisable for our legal position (for example, regarding
          applicable statutes of limitations, litigation or regulatory investigations).</p>

          <h1 class="wandr-title-1 mb-0 fw-bold">Disclosure of Data</h1>
          <h2 class="wandr-subtitle-1 mb-0 fw-bold">Legal Requirements</h2>

          <p>Wandr-E may disclose your Personal Data in good faith that such action is necessary to:</p>

          <ul>
            <li>To comply with a legal obligation;</li>
            <li>To protect and defend the rights or property of Wandr-E;</li>
            <li>To prevent or investigate possible wrongdoing in connection with the Services;</li>
            <li>To protect the personal safety of users of the Services or the public;</li>
            <li>To protect against legal liability.</li>
          </ul>

          <h1 class="wandr-title-1 mb-0 fw-bold">Security of Data</h1>
          
          <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data,
          we cannot guarantee its absolute security.
          </p>

          <h1 class="wandr-title-1 mb-0 fw-bold">Service Providers</h1>

          <p>We may employ third party companies and individuals to facilitate the provision of our Services ("Service Providers"), to
          provide the Services on our behalf, to perform services relating to the Services, or to assist us in analysing how our
          Services are used.
          </p>

          <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to
          disclose or use it for any other purpose.</p>

          <p>Additionally, we may disclose applicable personal information including, but not limited to, your name, contact information,
          national identification number, customer ID number, address, transaction patterns and bank account information to the
          following types of organisations and/or parties;</p>

          <ul>
            <li>Wandr-E group companies and affiliates;</li>
            <li>Our Agents or business partners who facilitate the money transfer transaction or specific service you have requested;</li>
            <li>Vendors, payments processors, banking partners and data processors contracted to provide business and customer services;</li>
            <li>Customer services, based on your consent where applicable, including marketing, advertising and customer satisfaction and market research on our behalf;</li>
            <li>Vendors and data processors contracted to help us validate the accuracy of the information provided by you, and to authenticate your identity and manage risks related to security, fraud and identity.</li>
            <li>Third parties that you have authorised to access your account and/or your account information in order to
              perform Services for you, such as account information Service Providers and payment initiation Service
              Providers.
            </li>
          </ul>

          <p>We may also transmit personal information we possess in connection with a sale or transfer of all or part of our business.
          We may also disclose your personal information globally, as required or permitted by applicable laws and regulations, to
          regulatory and financial authorities, credit reporting agencies, law enforcement bodies, courts, governments or
          government agencies, to meet compliance and legal obligations or to assert or defend the rights and interests of
          Wandr-E or others.</p>

          <h2 class="wandr-subtitle-1 mb-0 fw-bold">Analytics</h2>

          <p>We may use third-party Service Providers to monitor and analyse the use of our Services, including but not limited to:</p>

          <ul>
            <li><b>Google Analytics</b>
              <p>Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google
              uses the data collected to track and monitor the use of our Services. This data is shared with other Google
              services. Google may use the collected data to contextualize and personalize the ads of its own advertising
              network.</p>

              <p>You can opt-out of having made your activity on the Services available to Google Analytics by installing the
              Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js,
              analytics.js, and dc.js) from sharing information with Google Analytics about visits activity.</p>

              <p>For more information on the privacy practices of Google, please visit the Google Privacy & Terms web
              page: <a href="#" @click="followLink('mkt','https://policies.google.com/privacy?hl=en')">https://policies.google.com/privacy?hl=en</a></p>
            </li>
          </ul>

          <h1 class="wandr-title-1 mb-0 fw-bold">Links to Other Sites</h1>

          <p>Our Services may contain links to other sites that are not operated by us. If you click on a third-party link, you will be
          directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>

          <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites
          or services.</p>
          
          <h1 class="wandr-title-1 mb-0 fw-bold">Children's Privacy</h1>

          <p>Our Services do not address anyone under the age of 18 ("<b>Children</b>").</p>

          <p>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or
          guardian and you are aware that your Children have provided us with Personal Data, please contact us. If we become
          aware that we have collected Personal Data from Children without verification of parental consent, we shall take steps to
          remove that information from our servers.</p>

          <h1 class="wandr-title-1 mb-0 fw-bold">Changes to This Privacy Policy</h1>

          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy
          on this page.</p>

          <p>We will let you know via email and/or a prominent notice on our Services, prior to the change becoming effective and
          update the effective date at the top of this Privacy Policy.</p>

          <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective
          when they are posted on this page.</p>

          <h1 class="wandr-title-1 mb-0 fw-bold">Contact Us</h1>

          <p>If you have any questions about this Privacy Policy, please contact us:</p>

          <ul>
            <li>By email: <a href="#" @click="followLink('email', 'dpo@wandr-e.com')">dpo@wandr-e.com</a></li>
            <li>By visiting this page on our website: <a href="#" @click="followLink('mkt','https://www.wandr-e.com/contactus')">https://www.wandr-e.com/contactus</a></li>
          </ul>
        </div>
        <!-- <div class="static-content" v-html="privacyPolicyContent"> -->
        <!-- </div> -->
        
    </f7-block>
  </f7-page>
</template>

<script>
  //import ApiService from '../services/api-main';
  import { translation } from '@/plugins/i18n'
  import { mapGetters } from "vuex";

  export default {    
    mounted (){

      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })


      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      const moment= require('moment');
      let formattedMonth = moment(mm, 'M').locale(translation.currentLanguage).format('MMMM');


      this.updatedDate = dd + ' ' + formattedMonth + ' ' + yyyy;
    
      //this.loadPrivacyPolicy();
    },

    data() {
      return {
          helptText: [],
          privacyPolicyContent: [],
          updatedDate: '',
      };
    },

    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      async loadPrivacyPolicy(){ 

        const self = this;
        self.showPreloader();
          
        const privacyPolicy =  await this.$api.staticData.getHelpText(31);
        console.log(privacyPolicy);

        self.helptText = privacyPolicy[0];
        self.privacyPolicyContent = self.helptText.content[0].value;
        console.log(self.privacyPolicyContent);

        self.hidePreloader();
      },

      goBack() {
        this.$f7router.back({ transition: 'f7-push' });
      },

      followLink(linkType, linkRef){
        console.log("FOLOOW LINK", linkRef)
        
        if(linkRef){
          if (window.Android) {
            window.Android.getWandrCallback(JSON.stringify({ "type": 'open_page','data': linkRef}));
          } else if (window.webkit) {
            window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'open_page', 'data': linkRef}));
          } else {
            let linkToOpen = linkRef
            switch(linkType){
              case 'email': linkToOpen = "mailto:"+linkRef; break;
              default: break;
            }
            window.open(linkToOpen);
          }
        }
      },
    },

    components: {
 
    },

    computed: {
			...mapGetters('misc', ['linkMarketing'])
    },
  }
</script>
